import colors from 'style-utils/colors';

const radioInputTheme = {
  radioInput: {
    label: {
      fontFamily: `var(--primary-font-family)`,
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      color: colors.blackTwelve,
    },
    indicator: {
      boxShadow: 'inset 0px 1px 3px rgba(0, 0, 0, 0.5)',
      border: 'none',
      width: '16px',
      height: '16px',
      background: colors.white,
      margin: '0 4px 0 0',
      beforePseudoElement: {
        width: 'inherit',
        height: 'inherit',
        borderRadius: 'inherit',
        opacity: 0,
        backgroundSize: 'cover',
      },
    },
  },
};

export default radioInputTheme;
